import { BaseCallback, BaseModuleConfig } from '@/types'

const requireModuleConfigs = require.context('@/modules/', true, /(\.ts)$/)

const moduleConfigs = new Map<string, BaseModuleConfig<any>[]>()

function importModuleConfigs<T>(moduleKeySuffix: string, moduleNames: string[]): BaseModuleConfig<T>[] {
  const importedModuleConfigs: BaseModuleConfig<T>[] = []

  if (!moduleKeySuffix.endsWith('.ts')) moduleKeySuffix = `${moduleKeySuffix}.ts`

  requireModuleConfigs.keys()
    .filter((moduleKey) => moduleKey.endsWith(moduleKeySuffix))
    .forEach((moduleKey) => {
      const moduleName = moduleKey.split('/')[1]
      const moduleValue = requireModuleConfigs(moduleKey).default

      if (moduleNames.includes(moduleName)) importedModuleConfigs.push({ moduleName, moduleValue })
    })

  return importedModuleConfigs
}

export function loadModuleConfigs<T>(moduleKeySuffix: string, moduleNames: string[], moduleConfigCallback: BaseCallback<BaseModuleConfig<T>>): void {
  const loadedModuleNames = moduleConfigs.get(moduleKeySuffix)?.map(({ moduleName }) => moduleName) ?? []

  moduleNames = moduleNames.filter((moduleName) => !loadedModuleNames.includes(moduleName))

  importModuleConfigs<T>(moduleKeySuffix, moduleNames).forEach((moduleConfig) => {
    moduleConfigCallback(moduleConfig)

    moduleConfigs.set(moduleKeySuffix, moduleConfigs.get(moduleKeySuffix)?.concat(moduleConfig) ?? [moduleConfig])
  })
}